module.exports = __webpack_public_path__ + "img/logo_2.b5ddd40d.png";